import { render, staticRenderFns } from "./Operate.vue?vue&type=template&id=c6b2f4d6&scoped=true&"
import script from "./Operate.vue?vue&type=script&lang=js&"
export * from "./Operate.vue?vue&type=script&lang=js&"
import style0 from "./Operate.vue?vue&type=style&index=0&id=c6b2f4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b2f4d6",
  null
  
)

export default component.exports